import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingCTA from "@/components/FloatingCTA";
import ConsentBanner from "@/components/ConsentBanner";
import { usePageViewTracking } from "@/hooks/usePageViewTracking";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  usePageViewTracking();
  const isImmersive = location.pathname === "/elevate-moment" || location.pathname.startsWith("/admin");

  if (isImmersive) {
    return <>{children}</>;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingCTA />
      <ConsentBanner />
    </div>
  );
};

export default Layout;
